import { Routes } from '@angular/router';
import { EditTerroirComponent } from './edit-terroir/edit-terroir.component';
import { ListeTerroirsComponent } from './liste-terroirs/liste-terroirs.component';

export const TERROIRS_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const TERROIRS_ROUTES: Routes = [
    { path: '', component: ListeTerroirsComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditTerroirComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditTerroirComponent, data: { roles: ['ORGANISME'] } }
];
